import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookLeadForm = (props: { pageId?: number } = {}) =>
  useQuery<crmModels.IFacebookLeadForm[]>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/crm/facebook/lead-form',
          query: {
            pageId: props?.pageId
          }
        })
      );

      return res?.data?.data;
    },
    enabled: !!props?.pageId
  });
